import React from 'react';
import ProfessionalDashboard from '../ProfessionalDashboard/ProfessionalDashboard';

const Dashboard = () => {
  return (
    <div>
      <ProfessionalDashboard />
    </div>
  );
};

export default Dashboard;